import React from "react";
import "./IconButton.style.css";

function IconButton({ children, onClick, styles, isDisabled = false }) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={`bootstrapiso icon-button ${isDisabled && "disabled"}`}
        style={styles}
        disabled={isDisabled}
      >
        {children}
      </button>
    );
  }
export default IconButton;
  